interface IAddress {
  street1: string;
  street2: string;
  address?: string;
  neighborhood: string | null;
  country: string;
  city: string;
  state: string;
  postalCode?: string | null;
}

export enum PostalCodeLength {
  BR = 9,
  CO = 6,
  EC = 5,
  MX = 6,
  PA = 4,
  PE = 4,
  PH = 4,
  ZA = 4,
}

export default IAddress;
